export function getStoreName(name: string): string {
  return `@zustand/${name}`;
}

export function isIOS(): boolean {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent || navigator.vendor);
}
